import { Component, LOCALE_ID } from '@angular/core';
import { environment } from '../environments/environment';
import { registerLocaleData } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import localeFr from '@angular/common/locales/fr';

// Services
import { AuthService } from 'src/app/_services';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

// Modals Module
import { ModalsModule } from 'src/app/all/_popup_modals/modals.module';
import { VersionCheckService } from './_services/version-check.service';

// Enregistrement des locales françaises
registerLocaleData(localeFr, 'fr');

declare var profitwell;
declare var Tawk_API: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
      MessageService,
      { provide: LOCALE_ID, useValue: 'fr-FR'}
    ],
    imports: [
        ToastModule,
        RouterOutlet,
        ModalsModule
    ]
})
export class AppComponent {
  title = 'app';
  public notificationsOptions = {
    position: ["bottom", "right"],
    timeOut: 5000,
    lastOnBottom: true,
    clickToClose:true,
    animate:"fromRight",
    showProgressBar:false
  }
  public alertsOptions={}
  public confirmationsOptions={}

  constructor(
    private authService:AuthService,
    public vc: VersionCheckService
  ){
    vc.start(60_000); 
  }

  ngOnInit(): void {
    console.log("APP")
    this.authService.getUserLicence();
    this.emitToProfitwell();
    // when you're inside input number, and you scroll the value changes (this to disable it)
    this.diableInputNumberScrollChange();
    if (!environment.onPremise) {
      const currentUser = this.authService.currentUser || {};
      if (currentUser?.email) {
        Tawk_API.visitor = {
          name: currentUser.firstName + " " + currentUser.lastName,
          email: currentUser.email
        };
      }
    }
  }
  private emitToProfitwell(){
    let currentUser = this.authService.getAuthUser();
    if(environment.production && currentUser){
      profitwell('start', { 'user_email': currentUser["email"] });
    }
  }

  private diableInputNumberScrollChange(){
    document.addEventListener("wheel", function(event){
      const numberInput = (<HTMLInputElement>document.activeElement);
      if (numberInput.type === "number") {
        numberInput.blur();
      }
    });
  }

}
